// ZumRailsOnboarding.cshtml: ZumRails' hosted application form, with the cardholder's status above it.
import { useQuery } from '@tanstack/react-query';
import { appConfig } from '../api';
import { usePageTitle } from '../components/CustomerLayout';
import { useUser } from '../components/RequireAuth';
import { zumRailsStatus } from '../routing';

export function ZumRailsOnboardingPage() {
  usePageTitle('Set Up Your Card');
  const user = useUser();
  const config = useQuery({ queryKey: ['bff', 'app-config'], queryFn: appConfig, staleTime: Infinity });
  const status = zumRailsStatus(user.cardStatus);

  return (
    <>
      <h1 className="qcw-greeting">Let&apos;s get your card set up</h1>
      <p className="qcw-subgreeting">Complete the application below -- it only takes a few minutes.</p>

      <section className="qcw-section" style={{ marginBottom: 20 }}>
        <div style={{ padding: '18px 20px 0' }}>
          <h2 className="qcw-section-title" style={{ padding: '0 0 4px' }}>
            {status.label}
          </h2>
          <p className="qcw-empty" style={{ padding: '0 0 18px' }}>
            {status.action}
          </p>
        </div>
      </section>

      <section className="qcw-section" style={{ overflow: 'hidden' }}>
        {config.data && (
          <iframe
            style={{ border: 0, display: 'block', minHeight: 760, width: '100%' }}
            src={config.data.zumRailsOnboardingUrl}
            title="Card application"
            loading="eager"
            allow="clipboard-read; clipboard-write"
          ></iframe>
        )}
      </section>
    </>
  );
}
